import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import styles from "./PageHeader.module.css";
const getInitials = (name) => {
    return name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
};
export const PageHeader = ({ title, userName, userAvatar, }) => {
    const [imageError, setImageError] = useState(false);
    const displayName = userName || "User";
    const shouldShowUserSection = Boolean(displayName || userAvatar);
    return (_jsxs("header", { className: styles.header, children: [title && (_jsx("div", { className: styles.titleSection, children: _jsx("h1", { className: styles.title, children: title }) })), shouldShowUserSection && (_jsxs("div", { className: styles.userSection, children: [_jsx("div", { className: styles.avatar, children: !imageError && userAvatar ? (_jsx("img", { src: userAvatar, alt: `${displayName} avatar`, className: styles.avatarImage, onError: () => setImageError(true) })) : (_jsx("div", { className: styles.avatarFallback, children: getInitials(displayName) })) }), _jsx("div", { className: styles.userInfo, children: _jsx("div", { className: styles.userName, children: displayName }) })] }))] }));
};
